// extracted by mini-css-extract-plugin
module.exports = {"page":"Page10_page__3yqUZ","bg":"Page10_bg__2QEYF","text":"Page10_text__1wv_A","text2":"Page10_text2__3a_9b","message":"Page10_message__3IG64","bg2":"Page10_bg2__GyRn9"};